// Vuetify 1.5 detaches menus (selects, autocompletes, date pickers) to the app root and
// positions them against the window. Our forms scroll inside inner containers
// (e.g. .ops-entry-form-body), so an open menu would stay put while its field scrolls away.
// When an ancestor of a menu's activator scrolls, re-measure the menu so it follows the
// field, and close it once the field leaves that container's visible area.
const openMenus = new Set();
let scrolledContainer = null;

function syncOpenMenus(container) {
  const bounds = container.getBoundingClientRect();
  openMenus.forEach((menu) => {
    const activator = menu.getActivator();
    if (!activator || !container.contains(activator)) return;
    const rect = activator.getBoundingClientRect();
    if (rect.bottom < bounds.top || rect.top > bounds.bottom) {
      menu.isActive = false;
    } else {
      menu.updateDimensions();
    }
  });
}

function onScroll(event) {
  if (!openMenus.size || !(event.target instanceof Element)) return;
  const pending = scrolledContainer;
  scrolledContainer = event.target;
  if (pending) return;
  requestAnimationFrame(() => {
    const container = scrolledContainer;
    scrolledContainer = null;
    syncOpenMenus(container);
  });
}

export default {
  install(Vue) {
    Vue.mixin({
      mounted() {
        if (this.$options.name !== "v-menu") return;
        this.$watch(
          "isActive",
          (active) => (active ? openMenus.add(this) : openMenus.delete(this)),
          { immediate: true }
        );
      },
      beforeDestroy() {
        if (this.$options.name === "v-menu") openMenus.delete(this);
      },
    });
    document.addEventListener("scroll", onScroll, {
      capture: true,
      passive: true,
    });
  },
};
